import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSalesSerial(params) {
	return client.get("api/sales-serial/data", {
		params: params,
	});
}

function exportSalesSerial(params) {
	return client.get("api/sales-serial/export", {
		params: params,
	});
}

export default {
	getSalesSerial,
	exportSalesSerial,
};